/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * [description]
 *
 * @function Phaser.Geom.Line.CopyFrom
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} source - [description]
 * @param {Phaser.Geom.Line} dest - [description]
 *
 * @return {Phaser.Geom.Line} [description]
 */
var CopyFrom = function (source, dest)
{
    return dest.setTo(source.x1, source.y1, source.x2, source.y2);
};

module.exports = CopyFrom;



//////////////////
// WEBPACK FOOTER
// ./geom/line/CopyFrom.js
// module id = 706
// module chunks = 0